import { render, staticRenderFns } from "./singleSwitch.vue?vue&type=template&id=44efb529"
import script from "./singleSwitch.vue?vue&type=script&lang=js"
export * from "./singleSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports